export const reduxFormFieldNames = {
  partnerId: "partnerId",
  organizationId: "organizationId",
  facilityId: "facilityId",
  unitId: "unitId",
  allowHomeMonitor: "allowHomeMonitor",
  email: "email",
  patientEmail: "patientEmail"
};
